<template>
  <v-sheet
    v-if="!displayConfig.isKiosk"
    class="pa-2 pt-7"
    :width="'100%'"
    :min-width="350"
    :max-width="550"
    :elevation="4"
  >
    <v-form @submit.prevent="loginWithPassword()" validate-on="lazy" v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="emailOrUsername"
              label="Username (identikey)"
              :rules="usernameRules"
              density="compact"
              variant="outlined"
              hide-details="auto"
              required
              clearable
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="password"
              label="Password"
              type="password"
              :rules="passwordRules"
              density="compact"
              variant="outlined"
              hide-details="auto"
              required
              clearable
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn type="submit" color="primary">Log in</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-alert :icon="false" v-if="alert" type="error">{{ alert }}</v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-sheet>
  <KioskStudentIdentifier
    v-else
    v-model="kioskData"
    :button-text="'Log in'"
    @b-o-c="loginWithCardSwipe"
    @s-i-d="loginWithCardSwipe"
  >
    <template #description>
      <h1>Select your login method</h1>
      <p>
        You may choose to either enter your Student ID via a keypad or tap your Buff OneCard beside
        the kiosk.
      </p>
    </template>
  </KioskStudentIdentifier>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { useLoggedInUserStore } from '@/stores/loggedInUser'
import { useDisplayConfigStore } from '@/stores/displayConfig'
import KioskStudentIdentifier from './kiosk/KioskStudentIdentifier.vue'
import { type KioskStudentIdentifierModel, KioskStudentIdentifierState } from '@/types/kioskTypes'

export default defineComponent({
  name: 'Login',
  components: { KioskStudentIdentifier },
  data() {
    return {
      valid: false,
      emailOrUsername: '',
      password: '',
      usernameRules: [(v: string) => !!v || 'Email or username is required'],
      passwordRules: [(v: string) => !!v || 'Password is required'],
      alert: '',
      kioskData: undefined as KioskStudentIdentifierModel | undefined
    }
  },
  emits: ['close'],
  props: {
    redirectFrom: String
  },
  methods: {
    async loginWithPassword() {
      const userStore = useLoggedInUserStore()

      const user = this.emailOrUsername
      const password = this.password

      await userStore.loginWithUsernamePassword(user, password, this.redirectFrom, this.$router)

      if (userStore.isLoggedIn) {
        this.alert = ''
        this.$emit('close')
      } else {
        this.alert = 'Could not sign in. Please try again.'
      }
    },
    async loginWithCardSwipe() {
      const userStore = useLoggedInUserStore()
      if (!this.kioskData) return

      switch (this.kioskData.kioskState) {
        case KioskStudentIdentifierState.BOC:
          await userStore.loginWithCardSwipe(
            this.kioskData.identifier,
            '',
            this.redirectFrom,
            this.$router
          )
          break
        case KioskStudentIdentifierState.SID:
          await userStore.loginWithCardSwipe(
            '',
            this.kioskData.identifier,
            this.redirectFrom,
            this.$router
          )
          break
        default:
          return
      }

      if (userStore.isLoggedIn) {
        this.alert = ''
        this.$emit('close')
      } else {
        this.alert = 'Could not sign in. Please try again.'
      }
    }
  },
  setup() {
    const displayConfig = useDisplayConfigStore()

    return {
      displayConfig
    }
  }
})
</script>
